import firebase, { firestore, storage } from "../../firebase/firebase";

export const uploadAvatarImages = (imageURL, name, userId, cb) => {
  let NewImageUrl = imageURL.split(",")[1];
  return new Promise((res, rej) => {
    const uploadTask = storage
      .ref(`/users/${userId}/avatar/`)
      .child(name)
      .putString(NewImageUrl, "base64", { contentType: "image/png" });

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        var progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        cb(progress);
      },
      (err) => {
        console.log(err);
      },
      () => {
        storage
          .ref(`/users/${userId}/avatar/`)
          .child(name)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            res(fireBaseUrl);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    );
  });
};
